// State-wise reach — Lenovo India CSR (FY24-25)
// `state` names match those used by the India map component.

export const STATE_REACH = [
  { state: "Karnataka",      districts: 6, beneficiaries: 6800, fundedCr: 5.4, pillars: ["stem", "digital", "employability", "sustainability"] },
  { state: "Maharashtra",    districts: 5, beneficiaries: 5200, fundedCr: 4.6, pillars: ["stem", "employability", "sustainability"] },
  { state: "Uttar Pradesh",  districts: 3, beneficiaries: 3600, fundedCr: 2.0, pillars: ["digital"] },
  { state: "Gujarat",        districts: 3, beneficiaries: 2800, fundedCr: 1.6, pillars: ["digital"] },
  { state: "Tamil Nadu",     districts: 3, beneficiaries: 2400, fundedCr: 1.8, pillars: ["digital", "sustainability"] },
  { state: "Telangana",      districts: 2, beneficiaries: 1600, fundedCr: 1.1, pillars: ["employability"] },
  { state: "Delhi",          districts: 2, beneficiaries: 1500, fundedCr: 0.9, pillars: ["stem"] },
  { state: "Kerala",         districts: 3, beneficiaries: 1400, fundedCr: 1.5, pillars: ["sustainability"] },
  { state: "Puducherry",     districts: 1, beneficiaries: 1200, fundedCr: 1.3, pillars: ["employability"] },
  { state: "Jharkhand",      districts: 2, beneficiaries: 1100, fundedCr: 0.7, pillars: ["digital"] },
  { state: "Assam",          districts: 2, beneficiaries: 950,  fundedCr: 0.6, pillars: ["digital"] },
  { state: "Manipur",        districts: 1, beneficiaries: 700,  fundedCr: 0.5, pillars: ["stem"] },
  { state: "Meghalaya",      districts: 1, beneficiaries: 650,  fundedCr: 0.5, pillars: ["stem"] },
  { state: "Uttarakhand",    districts: 2, beneficiaries: 600,  fundedCr: 0.6, pillars: ["sustainability"] },
];

export const TOTAL_STATES = STATE_REACH.length;
export const TOTAL_DISTRICTS = STATE_REACH.reduce((s, x) => s + x.districts, 0);
